import { Fragment, useCallback, useContext, useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import AuthContext from "../../../../auth/AuthContext";
import AssessmentMasterService from "../../../../services/AssessmentMasterService";
import AlertService from "../../../../services/AlertService";
import PracticalAttendeeCard from "./PracticalAttendeeCard";
import { Skeleton } from "primereact/skeleton";
import SharedService from "../../../../services/SharedService";

const AssessmentPracticalAttendees = () => {
    const navigate = useNavigate();
    const { assessmentName } = useParams();
    const { state } = useLocation();
   const storedId = sessionStorage.getItem("assessmentId");
   const id = state?.id || state?.assessmentId || storedId;
    const [loading, setLoading] = useState(false);
    const [attendees, setAttendees] = useState([]);
    const authContext = useContext(AuthContext);

    const assessmentAccess = authContext.getPermissions("assessments");
    if (assessmentAccess.filter((f) => f.access.includes(1)).length === 0) {
        navigate("/");
    }
const loadAttendees = useCallback(async (signal) => { 
    setLoading(true);
    try {
      const data = await AssessmentMasterService.GetPracticalAttendees(
        id,
        '',
        authContext,
        signal 
      );

      if (signal?.aborted) return;

      if (data.isSuccess) {
        let i = 0;
        data.data.results.forEach((element) => {
          i++;
          element.no = i;
        });
        setAttendees(data.data.results);
      } else {
        AlertService.error(data.errorMessage);
      }
    } catch (err) {
      if (err.name === "AbortError") return; 
    } finally {
      if (!signal?.aborted) setLoading(false); 
    }
  }, [authContext, id]);

useEffect(() => {
    const controller = new AbortController();
    loadAttendees(controller.signal); 
    return () => controller.abort(); 
  }, [loadAttendees, authContext]);

    const onCardClick = async (id, name) => {
        navigate(`/masters-assessments/${assessmentName}/practical-attendees/${SharedService.GenerateSlug(name)}`, { state: { id, assessmentId:id } });
    };

    return (
        <Fragment>
            <div className="container-fluid pt-3 mt-3">
                <div className="row">
                          {loading ? (
                        Array.from({ length: 12 }).map((_, idx) => (
                          <div key={idx} className="col-lg-4 col-md-6 col-sm-12 p-3">
  <div className="card border-0 shadow-sm p-3 h-100">
    
    <div className="d-flex flex-wrap align-items-center">
      
      {/* Left Icon */}
      <div className="me-3 mb-2">
        <Skeleton size="4rem" shape="circle" />
      </div>

      {/* Content */}
      <div className="flex-grow-1 mb-2">
        <div className="title">
          <Skeleton width="100%" height="1.2rem" />
        </div>
        <div className="pt-1">
          <Skeleton width="80%" height="1.2rem" />
        </div>
        <div className="pt-1">
          <Skeleton width="60%" height="1.2rem" />
        </div>
      </div>

      {/* Right Icon */}
      <div className="ms-auto mb-2">
        <Skeleton size="4rem" shape="circle" />
      </div>

    </div>
  </div>
</div>
                        ))) :
                        (attendees &&
                            attendees.map((attendee, i) => (
                                <div key={i} className="col-lg-4 col-md-4 col-sm-6 col-12 p-3">
                                    <PracticalAttendeeCard
                                        id={attendee.id}
                                        data={attendee}
                                        clickHandler={(id, name) => onCardClick(id, name)}
                                    ></PracticalAttendeeCard>
                                </div>
                            )))}
                    {!loading && attendees && attendees.length === 0 && (
                        <div className="col-12 p-3 text-center">No data available...</div>
                    )}
                </div>
            </div>
        </Fragment>
    );
};

export default AssessmentPracticalAttendees;
